import { queryKeys } from '@query/keys'
import { PaginatedQueryResult, usePaginatedQuery } from '@query/usePaginatedQuery'

import { useAccountReadContext } from '@app/context/AccountContextContext'
import { useSessionLanguage } from '@app/context/SessionSettingsContext'

import { SortOrder, useApiClient } from '@utils/ApiClient'
import { ClientApiClient } from '@utils/clientApi'

import { ClientJourneyMapDto } from '@model/ClientJourneyMap'
import { FilterQueryProps } from '@model/FilterFields'

interface BrokerSummaryFetchProps {
  search: SearchResponseProps
}

interface SearchResponseProps {
  search: FilterQueryProps
  debouncedSearchTerm: string | null
}

export const defaultCJMSort: { sort: string; sortOrder: SortOrder }[] = [
  { sort: 'LinkClickedDate', sortOrder: 'DESC' },
]

export const useIBClientJourneyMapData = (
  props: BrokerSummaryFetchProps
): { query: PaginatedQueryResult<ClientJourneyMapDto> } => {
  const apiClient = useApiClient(ClientApiClient)
  const { account } = useAccountReadContext()
  const { search } = props
  const locale = useSessionLanguage()

  const ibId = account?.clientIntroducingBroker?.id

  const searchKey = {
    ...search.search,
    ca_search_Name: search.debouncedSearchTerm,
    locale,
  }

  const query = usePaginatedQuery({
    queryKey: queryKeys.ib.clientJourneyMapData(ibId, searchKey, locale),
    queryFn: (pageQuery) =>
      apiClient.getClientJourneyMapData(ibId ?? '', {
        ...pageQuery,
        search: {
          ...search.search,
          ca_search_Name: search.debouncedSearchTerm,
        },
        sort: pageQuery?.sort ?? defaultCJMSort,
        caller: 'ca',
        languageId: locale,
      }),
  })

  return { query }
}
